<template>
  <div class="searchFriend page">
    <app-bar class="f-s-16" color="#333333" background="#FFF" nomenu :isBack="false">
      <div slot="title">
        <div class="search-block">
          <img class="icon_search_g" src="../assets/img//icon_search_g.png" alt="">
          <input class="search-input" v-model="serachValue" @keyup.enter="serachFriends()" placeholder="请输入好友ID" type="text" >
        </div>
      </div>
      <div slot="right" class="close" @click="$router.back()">
        取消
      </div>
    </app-bar>
    <div></div>
    <div class="friend-list">
      <mu-load-more :loading="loading" @load="getFriends">
        <div class="friend-list-item" v-for="(item, index) in list" :key="`item${index}`">
          <div class="d-flex justify-space-between t-left">
            <div class="d-flex">
              <img class="head" width="42" height="42" :src="item.ico ? item.ico : require('../assets/img/icon_defaulthead.png')" alt="">
              <div class="name-firend d-flex flex-column">
                <div class="name f-s-16 c-black-3">{{item.alias}}(ID:{{item.userId}})</div>
                <div class="time f-s-12 c-black-9">邀请于:{{new Date(item.regTime).getFullYear()}}/{{new Date(item.regTime).getMonth()+1}}/{{new Date(item.regTime).getDate()}} {{new Date(item.regTime).getHours()}}:{{new Date(item.regTime).getMinutes()}}</div>
                <div class="status f-s-12 c-black-9">好友状态：{{item.stepStatus == 1 ? '已注册' : item.stepStatus == 2 ? '完成新手任务' : '已提现'}}<span></span><span v-if="item.cmpDays">·已签到{{item.cmpDays}}天</span></div>
              </div>
            </div>
          </div>
        </div>
      </mu-load-more>
      <div class="no-res" v-if="list && list.length == 0">
        <img width="150" src="../assets/img/zql/myFriend/icon_friendnot.png" alt srcset />
        <div class="text">没有搜索到相关好友</div>
      </div>
    </div>
  </div>
</template>

<script>
import appBar from "../components/appBar"
export default {
  components: {
    appBar
  },
  data() {
    return {
      list : [],
      serachValue: '',
      loading: false,
      page: 1,
      pages: 4
    }
  },
  methods: {
    getFriends() {
      if (this.page <= this.pages) {
        this.loading = true
        this.$axios.post('/user/friends', {
          pageSize: 10,
          page: this.page,
          userNo: this.serachValue
        })
        .then(res => {
          this.loading = false
          if(res.code == 200) {
            this.page++
            this.list.push(...res.data.records)
            this.pages = res.data.pages
          }
        })
      }
    },
    serachFriends() {
      // console.log(key)
      if (this.page <= this.pages) {
        this.loading = true
        this.$axios.post('/user/friends', {
          pageSize: 10,
          page: 1,
          userNo: this.serachValue
        })
        .then(res => {
          this.loading = false
          if (res.code == 200) {
            this.list = []
            this.page++
            this.list = res.data.records
            this.pages = res.data.pages
          }
        })
      }
      this.$native.changeBarColor('black')
    }
  }
}
</script>

<style lang="less" scoped>
.page{
  height: 100%;
  background-color: #FFF;
  .search-block{
    margin: 0 12px 0 15px;
    position: relative;
    .icon_search_g{
      width: 16px;
      height: 15px;
      position: absolute;
      top: 50%;
      left: 14px;
      transform: translateY(-50%);
    }
    .search-input{
      height: 32px;
      width: 100%;
      border: none;
      background-color: #F5F5F5;
      border-radius: 4px;
      text-indent: 38px;
    }
  }
  .close{
    margin-right: 7px;
  }
  .friend-list{
    padding: 0 18px;
    border-top: 1px solid #CECECE;
    .friend-list-item{
      padding: 16px 0;
      border-bottom: 1px solid #DBDBDB;
      &:last-child{
        border-bottom: none;
      }
      .head{
        margin-right: 8px;
      }
      // .status{
      //   color: #FF691E;
      // }
    }
    .no-res{
      margin-top: 40px;
      .text{
        color: #303030;
        font-size: 16px;
      }
    }
  }
}
</style>